{
    "addToCart": "Add to cart",
    "yes": "Yes",
    "no": "No",
    "login": "Login",
    "cancel": "Cancel",
    "close": "Close",
    "couponApplied": "Coupon applied!",
    "unappliedCoupon": {
        "title": "Coupon not applied",
        "description": "Scan the matching product to receive the discount."
    },
    "done": "Done",
    "welcome": "Welcome",
    "welcomeScan": "Pay conveniently and easily via self-checkout",
    "total": "Total",
    "toPayment": "Pay",
    "back": "Back",
    "quantityNeeded": "Quantity needed",
    "confirmCart": "Are all of your items scanned?",
    "interactWithTerminal": "Interact with the payment terminal to finalize your purchase",
    "endTitle": "Purchase successful!",
    "endSubtitle": "You are good to go. We appreciate you shopping with us!",
    "feedbackQuestion": "How was your experience?",
    "endThanksForFeedback": "Thanks for your feedback!",
    "endSeeYouLater": "We can’t wait to see you again.",
    "getReceipt": "Receipt",
    "scanQRCode": "Scan this QR Code to download your digital receipt",
    "printReceipt": "Print receipt",
    "receiptPrinted": "✔ Receipt printed",
    "finalizeSession": "Finalize session",
    "productNotFound": "Oops! We can’t find this item",
    "okDismiss": "OK",
    "somethingWentWrong": "Something went wrong",
    "pleaseTryAgain": "Please try again",
    "pleaseWait": "One moment...",
    "tryAgain": "Try again",
    "reload": "Reload",
    "stillThere": "Are you still there?",
    "continue": "Continue",
    "startOver": "Start over",
    "scan": "Scan an item to add it to your cart",
    "wantToStartOver": "Are you sure you want to start over?",
    "wantToStartOverDescription": "You will lose your scanned cart items and applied discounts.",
    "changeLanguage": "Change language",
    "ageVerification": "Scan ID to Verify Age",
    "scanId": "In order to buy this product you need to <strong>scan your identification</strong> to verify your age.",
    "holdIdSteady": "<strong>Note:</strong> Please hold your ID steady towards the scanner",
    "sorryCantSell": "Sorry, we can’t sell you this product",
    "sorryCantSellDescription": "We can only sell this product to persons 18 or older",
    "invalidId": "We couldn’t read the ID you provided. Please try again.",
    "verificationSuccessful": "Verification successful!",
    "startShopping": "Start shopping",
    "startShoppingKitchen": "Order food",
    "wantToDeleteLineItem": "Are you sure you want to delete the item?",
    "wantToDeleteLineItemDescription": "The product will be deleted from your cart.",
    "promotionsDontWork": "<strong>Note:</strong> Products on promotion don’t yet work with self-checkout",
    "addToBasket": "Hinzufügen",
    "promo": "Promo",
    "product": "Product",
    "productAdded": "Product added!",
    "product_other": "Products",
    "operatorModeDialog": {
        "title": "Need help?",
        "description": "Please scan your employee badge for more actions."
    },
    "orderList": {
        "collapseDetails": "Collapse",
        "expandDetails": "Expand",
        "details": "Details",
        "title": "Orders"
    },
    "checkoutError": {
        "default": "Oops, your payment failed. Please try again.",
        "AbortedByUser": "The payment was canceled, please try again.",
        "PaymentDeviceNotFound": "Für diesen SCO konnte kein Payment Terminal gefunden werden.",
        "CouponNotFound": {
            "title": "Coupon Not Found",
            "description": "This coupon cannot be applied as it cannot be found."
        },
        "CouponNotApplicable": {
            "title": "Coupon Not Applicable",
            "description": "This coupon doesn't match any items in your cart. Please scan the product first."
        },
        "CouponExpired": {
            "title": "Coupon Expired",
            "description": "This coupon cannot be applied as it has expired."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon Already Used",
            "description": "This coupon cannot be applied as it has already been used."
        },
        "CouponRedemptionFailed": {
            "title": "Coupon Redemption Failed",
            "description": "The coupon could not be redeemed. Please try again."
        }
    },
    "operatorMode": "Operator mode",
    "operator": {
        "configuration": {
            "title": "Configuration",
            "individualConfig": {
                "title": "SCO configuration"
            },
            "storeConfig": {
                "title": "Store configuration"
            },
            "status": {
                "label": "SCO enabled",
                "confirmDisable": "Are you sure you want to disable the SCO?",
                "confirmEnable": "Are you sure you want to enable the SCO?"
            },
            "cartCheck": {
                "label": "Cart check enabled",
                "confirmDisable": "Are you sure you want to disable the cart check?",
                "confirmEnable": "Are you sure you want to enable the cart check?"
            }
        },
        "hardware": {
            "title": "Hardware",
            "lamp": "Lamp",
            "printer": "Printer",
            "scanner": "Scanner",
            "red": "Red",
            "green": "Green",
            "print": "Print dummy receipt",
            "clear": "Clear",
            "blink": "Blink",
            "paymentTerminal": "Payment terminal",
            "login": "Login",
            "paymentDeviceConfig": {
                "currentIp": "Current IP address",
                "ipLabel": "New IP address",
                "invalidIp": "Invalid IP address",
                "setIp": "Set IP",
                "probe": "Probe",
                "probeSucceeded": "Probe succeeded",
                "probeFailed": "Probe failed",
                "loginSucceeded": "Login succeeded",
                "loginFailed": "Login failed: {{reason}}",
                "status": "Status",
                "statuses": {
                    "ready": "Ready",
                    "requiresLogin": "Requires login",
                    "unreachable": "Unreachable"
                },
                "ipUpdated": "IP address updated",
                "ipUpdateFailed": "Failed to update IP address: {{reason}}",
                "alterIp": "Change IP",
                "dialogTitle": "Payment terminal IP",
                "close": "Close"
            }
        },
        "systemInformation": {
            "title": "System information",
            "deviceId": "Device ID",
            "cashRegisterId": "SAP cash register ID",
            "paymentDeviceId": "Payment device ID",
            "paymentDeviceIp": "Payment device IP",
            "runningVersion": "Running version",
            "storeId": "Store ID",
            "productPresetIds": "Product preset IDs",
            "kitchenMenuId": "The Kitchen menu ID",
            "tenant": "Tenant"
        }
    },
    "order": "Order",
    "order_other": "Orders",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Group by",
        "scoId": "Self-checkout",
        "category": "Category"
    },
    "productCategory": {
        "label": "Category",
        "ABF": "Waste",
        "BTRM": "Operating resources",
        "BUCH": "Books",
        "CBAU": "Compatible unit",
        "CH00": "CH Contract management",
        "CONT": "KANBAN container",
        "COUP": "Coupon",
        "DIEN": "Service not ordered",
        "DLU1": "Service ordered",
        "EPA": "Equipment package",
        "ERSA": "Spare parts",
        "FERT": "Finished product",
        "FGTR": "Beverages",
        "FHMI": "Production aids",
        "FOOD": "Food (fresh food excl.)",
        "FRIP": "Fresh products",
        "HALB": "Semi-finished product",
        "HAWA": "Merchandise",
        "HERS": "Manufacturer part",
        "HIBE": "Auxiliary/operating materials",
        "IBAU": "Maintenance assembly",
        "INTR": "Intra material",
        "KMAT": "Configurable material",
        "LEER": "Empties",
        "LEIH": "Returnable packaging material",
        "LGUT": "Empties (after VOLL)",
        "MODE": "Fashion (seasonal)",
        "MPO": "Material planning object",
        "NLAG": "Non-storage material",
        "NOF1": "Non-food",
        "PIPE": "Pipeline material",
        "PLAN": "Merchandise (planned)",
        "PRES": "Press",
        "PROC": "Process material",
        "PROD": "Product group",
        "ROH": "Raw material",
        "TBAK": "Tobacco",
        "UNBW": "Unvalued material",
        "VBFO": "Consumable material FOOD",
        "VERP": "Packaging",
        "VKHM": "Additives",
        "VOLL": "Full product",
        "WERB": "Advertising material",
        "WERT": "Valuable material",
        "WETT": "Competitor product",
        "ZAUF": "Expense item",
        "ZAUS": "Press issue",
        "ZFRG": "Franchising fees",
        "ZGIF": "Ravita gift cards",
        "ZILV": "AGS: International service contract",
        "ZITP": "AGS: IT projects",
        "ZLEI": "Leihgut Kiosk AG",
        "ZLOG": "Services Logistics",
        "ZMFE": "AGS: Management fee",
        "ZOBJ": "Press - Object",
        "ZRAV": "Ravita PinCodes",
        "ZSER": "AGS: Service articles"
    },
    "totalRevenue": "Total revenue",
    "needReceipt": "<strong>Need a receipt?</strong> You can find it in the app under Settings > Purchase history",
    "orderNumber": "Order",
    "takeReceipt": "<strong>Important</strong>: Please take your ticket order and give it to the kitchen personnel when picking up your items.",
    "paymentSimulator": "Payment simulator",
    "success": "Success",
    "failure": "Failure",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Back to cart",
        "productUnavailable": "Not available",
        "allergens": "Allergens",
        "nutritionalInformation": "Ingredients and Origin",
        "productInformation": "Product Information",
        "upsellingTitle": "Feeling like something else?"
    },
    "availableAtAvec": "Available at this avec",
    "kitchenDescription": "Press the Kitchen button to open the menu",
    "unknown": "Unknown",
    "dateRangePicker": {
        "from": "From",
        "to": "To"
    },
    "outOfOrder": {
        "title": "Oops, we have a problem",
        "subtitle": "The self-checkout is temporarily out of order, but we’re working hard to fix it."
    },
    "cartCheckTriggered": "Your cart has been randomly selected for a manual check. Please wait for staff to come to you.",
    "cartError": {
        "Unknown": {
            "title": "Oops, we have a problem. Please try again"
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon Already Redeemed",
            "body": "The coupon has already been redeemed. Please check the coupon and try again."
        },
        "ServiceNotSellable": {
            "title": "Please use a staffed checkout",
            "body": "This item can only be purchased at a staffed checkout."
        },
        "CouponNotApplicable": {
            "title": "Coupon Not Applicable",
            "body": "This coupon doesn't match any items in your cart. Please scan the product first."
        }
    }
}
